import { Link } from 'react-router-dom';
import styles from './ReviewFilter.module.scss';

function ReviewFilter(props: { borderRadius?: number }) {
  return (
    <div
      className={styles.reviewFilter}
      style={{ borderRadius: props.borderRadius == 0 ? '0' : '10px' }}
    >
      <Link
        to={`${`/login?rurl=${
          window.location.pathname + window.location.search
        }`}`}
        className={styles.loginLink}
      >
        로그인하기 <span>〉</span>
      </Link>
      <p>
        의료법에 의거하여 의약품 후기는
        <br />
        로그인 후 보실 수 있습니다.
      </p>
    </div>
  );
}

export default ReviewFilter;
